import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import { useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { resultadoService } from '../../Services/Form';
import { ContainerButtonPlay } from '../../Utils/Button';
import { ContinuarVideo, RetrocederVideo } from './constants';
import { registrarVideo } from '../../Services/Productos';
import { IUserFromStorage } from '../../Interfaces/IUser';
import { IAcelerador, IMes, INivel, IResponseResultados } from '../../Interfaces/IAceleradores';
import Loading from '../../Utils/Loading';
import AceleradoresMobile from './AceleradoresMobile';
import VideoPlayer from '../../Components/VideoPlayer/VideoPlayer';

import { grayPlayButton } from '../../Shared/Images';
import LinkIcon from '@mui/icons-material/Link';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
// import atrasIcon from '../../../../Shared/Images/atras-icon.png';


import styles from '../../Components/Main/styles/resultadosPC.module.css';


const Aceleradores = () => {

  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width: 650px)');

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [change, setChange] = useState<boolean>(true);
  const [mostrarVideo, setMostrarVideo] = useState<boolean>(false);
  const [currentPosition, setCurrentPosition] = useState<number>(0);
  const [linkUrlPortadaMes, setLinkUrlPortadaMes] = useState<string>('');
  // const [currentPhase, setCurrentPhase] = useState<string>('Nivel 1');
  // const [currentMonth, setCurrentMonth] = useState<number>(1);

  // const [niveles, setNiveles] = useState<INivel[]>([]);
  const [meses, setMeses] = useState<IMes[]>([]);

  const [mesSelected, setMesSelected] = useState<IMes>();
  const [mesSelectedPosition, setMesSelectedPosition] = useState<number>(0);

  const [aceleradores, setAceleradores] = useState<IAcelerador[]>([]);
  const [selectedAcelerador, setSelectedAcelerador] = useState<IAcelerador>();


  let value = localStorage.getItem('user');
  let user : IUserFromStorage = typeof value === 'string' ? JSON.parse(value) : '';

  useEffect(() => {
    // setIsLoading(true);
    resultadoService({
      UsuarioTestAsesoriaID: user.usuarioTestAsesoriaID,
    })
      .then((response) => {
        if (response.data.status === 200) {
          if(response.data.data){

            const { linkUrlPortadaMes, niveles, mes, fase } : IResponseResultados = response.data.data;
            
            setLinkUrlPortadaMes(linkUrlPortadaMes);
            setMeses([]);

            if (niveles && niveles.length > 0) {

              if( niveles[0].meses.length > 0 ) {         
                niveles.forEach((nivel : INivel) => {
                  nivel.meses.forEach((mes : IMes) => {
                    setMeses(prev => [...prev, {mes : mes.mes, nivel: nivel.nivel, videos: mes.videos} ]);
                  });
                });

                if (
                  niveles[0].meses &&
                  niveles[0].meses[0]
                ) {

                  //~ Aplanamos el arreglo y lo mapeamos a la vez, no tenia idea de que existía flatMap, que útil resulta, gracias stackOverflow
                  const mesesPlanos = niveles.flatMap((nivel: INivel) =>
                    nivel.meses.map((mes: IMes) => ({
                      mes: mes.mes,
                      nivel: nivel.nivel,
                      videos: mes.videos
                    }))
                  );

                  //~ Buscamos el index del mes actual
                  let actualMonthIndex = mesesPlanos.findIndex(
                    (m : IMes) => m.mes === mes && m.nivel === fase
                  );

                  //~ Si no se encuentra, uso el primer mes
                  if (actualMonthIndex === -1) {
                    actualMonthIndex = 0;
                  }

                  //~ Seleccionamos el mes usando el index del mes actual
                  const mesEncontrado = mesesPlanos[actualMonthIndex] ?? {
                    mes: niveles[0].meses[0].mes,
                    nivel: niveles[0].nivel,
                    videos: niveles[0].meses[0].videos
                  };

                  //~ Guardamos en los estados y queda
                  setMesSelected(mesEncontrado);
                  setMesSelectedPosition(actualMonthIndex);
                }
              }
            }
          }
        }
      })
      .finally(() => {
        setIsLoading(false);

      })
  }, [change]);

  useEffect(() => {
    setMesSelected(meses[mesSelectedPosition]);
    setCurrentPosition(0);
    // console.log(mesSelectedPosition , 'Mes selected position');
  }, [mesSelectedPosition])

  useEffect(() => {
    if (mesSelected) {
      const aceleradoresMes = mesSelected.videos.map((video : IAcelerador, index) => ({
        ...video,
        index: index,
      }));
      setAceleradores(aceleradoresMes);
    }
    // console.log(mesSelected?.mes , 'Mes seleccionado -' , mesSelected?.nivel, 'Nivel seleccionado');
    // console.log(currentMonth , 'Mes actual -' , currentPhase, 'Nivel actual');
  }, [mesSelected])

  useEffect(() => {
    if(aceleradores && aceleradores.length > 0) {
      setSelectedAcelerador({
        descripcion:                  aceleradores[currentPosition]?.descripcion ?        aceleradores[currentPosition]?.descripcion :        aceleradores[0]?.descripcion,
        portada:                      aceleradores[currentPosition]?.portada ?            aceleradores[currentPosition]?.portada :            aceleradores[0]?.portada,
        retoTr4inerVideoPorUsuarioID: aceleradores[currentPosition]?.retoTr4inerVideoPorUsuarioID,
        titulo:                       aceleradores[currentPosition]?.titulo ?             aceleradores[currentPosition]?.titulo :             aceleradores[0]?.titulo,
        vimeoID:                      aceleradores[currentPosition]?.vimeoID ?            aceleradores[currentPosition]?.vimeoID :            aceleradores[0]?.vimeoID,
        videoRetoTr4inerID:           aceleradores[currentPosition]?.videoRetoTr4inerID ? aceleradores[currentPosition]?.videoRetoTr4inerID : aceleradores[0]?.videoRetoTr4inerID,
        index:                        aceleradores[currentPosition]?.index ?              aceleradores[currentPosition]?.index :              aceleradores[0]?.index
      })
    }
  }, [ currentPosition, aceleradores ])

  // useEffect(() => {
  //   console.log(niveles , 'Niveles');
  //   console.log(meses , 'Meses');
  //   console.log(mesSelected , ` ${currentMonth} ${currentPhase} Mes Seleccionado`);
  // }, [niveles, meses, mesSelected])

  function completarVideo(videoActual: IAcelerador) {
    if (videoActual.retoTr4inerVideoPorUsuarioID === 0) {
      registrarVideo({
        UsuarioTestAsesoriaID: user.usuarioTestAsesoriaID,
        RetroTr4inerVideoID: videoActual.videoRetoTr4inerID,
      })
        .then(() => {
          //quiero que cuando se complete el video, el videoActual cambie al video siguiente, y si es el último, que se muestre un mensaje de felicitaciones

          //primero, debo obtener el index del video actual
          const index = aceleradores.findIndex(
            (acelerador) => acelerador.index === videoActual.index,
          );
          //luego, si el index es menor a la cantidad de videos, cambio el video actual al siguiente
          if (index! < aceleradores.length! - 1) {
            setCurrentPosition( index! + 1 );
            setSelectedAcelerador(aceleradores[index + 1]);
            toast.success('Video completado');
          } else {
            //si no, muestro un mensaje de felicitaciones
            toast.success('Video completado');
            // toast.success('¡Felicidades! Has completado todos los videos 🎉');
          }
          setChange(!change);
        })
        .catch(() => {
          toast.error('Error al completar el video');
        })
    } else {
      toast.error('El video ya ha sido completado');
    }
  }

  const selectNextMonth = () => {
    if(mesSelectedPosition + 1 !== meses.length) {
      setMesSelectedPosition((c) => c + 1);
    } else {
      navigate('/producto/2');
    }
  }

  const selectPreviousMonth = () => {
    if(mesSelectedPosition !== 0) {
      setMesSelectedPosition((c) => c - 1);
    } else {
      navigate('/producto/2');
    }
  }


  return (
    <>
      {isLoading ? (
        <div className="h-[100dvh] flex items-center justify-center">
          <Loading />
        </div>
      ) : (
        isMobile ? (
          <AceleradoresMobile
            aceleradores={aceleradores}
            selectedAcelerador={selectedAcelerador}
            currentPosition={currentPosition}
            setCurrentPosition={setCurrentPosition}
            completarVideo={completarVideo}
            mesSelected={mesSelected}
            mesSelectedPosition={mesSelectedPosition}
            setMesSelectedPosition={setMesSelectedPosition}
            meses={meses}
            selectPreviousMonth={selectPreviousMonth}
            selectNextMonth={selectNextMonth}
            linkUrlPortadaMes={linkUrlPortadaMes}
          />
        ) : (
          <div className="p-4 flex flex-col items-center justify-center gap-4">
            <div className="md:h-[3vh] w-full"></div>

            {/* Menú superior */}
            <div className="w-full flex flex-row justify-around">

              <div>
                <button
                  onClick={selectPreviousMonth}
                  title={mesSelectedPosition === 0 ? 'Salir' : 'Mes anterior'}
                >
                  {mesSelectedPosition === 0 ? (
                    <CloseIcon fontSize='large' />
                  ) : (
                    <ArrowBackIosIcon fontSize='large' />
                  )}
                </button>
              </div>

              <div>
                <p className="m-0 title mb-2 text-[1.25rem]">
                  { (mesSelected || mesSelected?.nivel || mesSelected?.mes) ?  `${mesSelected?.nivel} - Mes ${mesSelected?.mes}` : 'Aceleradores'}
                </p>
              </div>

              <div>
                <button
                  onClick={selectNextMonth}
                  title={mesSelectedPosition === meses.length - 1 ? 'Salir' : 'Siguiente mes'}
                >
                  {mesSelectedPosition === meses.length - 1 ? (
                    <CloseIcon fontSize='large' />
                  ) : (
                    <ArrowForwardIosIcon fontSize='large' />
                  )}
                </button>
              </div>
            </div>
            {/* Fin del menú superior */}

            <div
              className={'flex flex-row justify-center w-full gap-12 px-[3rem] py-0'}
            >
              <section className={styles.containerVideo}>
                <div className="flex justify-start text-left w-full">
                  <p
                    className="m-0 title mb-2 text-[1.25rem]"
                    style={{ color: '#5F5F5F', fontWeight: 'bold' }}
                  >
                    {aceleradores.length > 0 ? selectedAcelerador?.titulo : ''}
                  </p>
                </div>
                {aceleradores && aceleradores.length > 0 && aceleradores[0]?.vimeoID && selectedAcelerador ? (
                  <>
                    <div className="w-[80%] my-4">
                      {!mostrarVideo ? (
                        <div
                          style={{
                            position: 'relative',
                          }}
                          className="relative"
                        >
                          <ContainerButtonPlay
                            onClick={() => {
                              setMostrarVideo(true);
                            }}
                          >
                            <img
                              src={grayPlayButton}
                              alt=""
                              width={80}
                              style={{ cursor: 'pointer' }}
                            />
                          </ContainerButtonPlay>

                          <img
                            width={'100%'}
                            height={'100%'}
                            src={selectedAcelerador?.portada}
                            alt="portada"
                          />
                        </div>
                      ) : (
                        <VideoPlayer
                          url={ selectedAcelerador?.vimeoID }
                          onEnded={() => completarVideo(selectedAcelerador)}
                        />
                      )}
                    </div>
                    <button
                      className="font-bold m-0 py-2 cursor-pointer text-slate-800 shadow-md rounded-lg bg-gray-300 flex self-start items-center gap-1 text-lg"
                      style={{
                        fontWeight: 'bold',
                        margin: 0,
                        padding: '0 30px',
                      }}
                      onClick={() => completarVideo(selectedAcelerador)}
                    >
                    <CheckCircleIcon
                      fontSize="small"
                      sx={{
                        color:
                          selectedAcelerador?.retoTr4inerVideoPorUsuarioID !== 0
                            ? 'green'
                            : 'gray',
                      }}
                    />{' '}
                    Completado
                    </button>
                    <div
                      style={{ textAlign: 'center', fontSize: '1rem', fontWeight: "500" }}
                      className="hind mt-3 w-full text-left"
                    >
                      {selectedAcelerador.descripcion && (
                        selectedAcelerador.videoRetoTr4inerID !== 14 ? (
                          <div style={{ textAlign: 'start' }} className="cardText" dangerouslySetInnerHTML={{ __html: selectedAcelerador?.descripcion }} >
                          {/* {selectedAcelerador?.descripcion} */}
                          </div>
                        ) : (
                          <div className="text-start flex flex-col">
                            <p className='text-[1rem] mb-0'>
                              <b className="text-[16px]">Con esto será IMPOSIBLE fallar.</b>
                              <br/>
                              No se trata de entrenar fuerte y comer bien un par de veces y esperar milagros. Si no tienes un sistema para asegurarte de que avanzas cada día, te quedarás igual. En este video te enseño el 
                              <b className="text-[16px]"> método </b>
                              que hace que progresar esté GARANTIZADO.
                              <br />
                            </p>
                            <a
                              href="https://bonostr4iner.s3.us-east-2.amazonaws.com/calendario_fit4_2025_1.pdf" 
                              target="_blank"
                              rel="noopener noreferrer"
                              className='text-base self-center no-underline hover:underline active:underline-offset-2'
                            >
                              <LinkIcon /> Descarga aquí el Sistema Visual para que seas constante
                            </a>
                          </div>
                        )
                      )}
                    </div>          
                  </>
                ) : (
                  <div
                    className="flex relative justify-center"
                  >
                    <img
                      style={{boxShadow: '0px 0px 14px 9px rgba(0,0,0,0.18)'}}
                      width={'80%'}
                      height={'80%'}
                      src={'https://bonostr4iner.s3.us-east-2.amazonaws.com/nivel3.jpg'}
                      alt="img"
                    />
                  </div>
                )}

              </section>
              

              {aceleradores && aceleradores.length > 0 && (
                <aside className={'pt-10 flex flex-col'}>
                    <p
                      className="fw-bold m-0 font-bold text-[1.3rem]"
                    >
                      ACELERADORES
                    </p>
                    <div className="h-[3px] self-center bg-gray-400 w-[98%] mt-2 "></div>
                    <div style={{ marginTop: '.5rem' }}>
                      
                        {aceleradores.map((video, i: number) => (
                          <div
                            key={i}
                            className={`flex items-center justify-between p-2 mb-1 w-full cursor-pointer ${selectedAcelerador?.index === i ? 'bg-[#e6e6e6]' : 'bg-[#fff] text-black hover:bg-[#fafafa] active:bg-[#e9e9e9]'}`}
                            onClick={() => {
                              setMostrarVideo(false);
                              setCurrentPosition(i);
                            }}
                            style={{
                            }}
                          >
                            <p
                              key={i}
                              className="m-0 text-left font-medium pr-12"
                            >
                              {i + 1}. {video.titulo}
                            </p>
                            {video.retoTr4inerVideoPorUsuarioID !== 0 && (
                              <CheckCircleOutlineIcon className="text-green-500" />
                            )}
                          </div>
                        ))}
                    </div>
                </aside>
              )}
            </div>

            {aceleradores && aceleradores.length > 0 && aceleradores[0]?.vimeoID && selectedAcelerador && (
              <section className='flex gap-2 items-center self-center justify-center pl-4 mt-5 mb-6 w-full'>
                { selectedAcelerador.index !== 0  ? (
                  <button
                    className={`font-bold m-0 py-2 cursor-pointer text-slate-800 shadow-md rounded-lg bg-[#d4d2d2] px-6 flex items-center gap-1 text-lg`}
                    style={{boxShadow: `
                      inset 0 4px 6px rgba(255, 255, 255, 0.3),
                      inset 0 -4px 6px rgba(0, 0, 0, 0.2),
                      0 4px 10px rgba(0, 0, 0, 0.25)
                    `}}
                    disabled={ currentPosition === 0 }
                    onClick={() => RetrocederVideo(currentPosition, aceleradores, setCurrentPosition)}
                  >
                    <ArrowBackIosIcon /> Anterior
                  </button>
                ) : (
                  <button
                    onClick={() => {
                      navigate('/producto/2')
                    }}
                    className="font-bold m-0 py-2 cursor-pointer text-white shadow-md rounded-lg bg-[#050505] pl-8 pr-9  flex items-center gap-1 text-lg"
                    style={{ boxShadow: `
                      inset 0 4px 6px rgba(255, 255, 255, 0.3),
                      inset 0 -4px 6px rgba(0, 0, 0, 0.2),
                      0 4px 10px rgba(0, 0, 0, 0.25)
                    ` }}
                  >
                    <ArrowBackIosIcon /> Salir
                  </button> 
                )}
                <button
                  className={`font-bold m-0 py-2 cursor-pointer text-slate-800 shadow-md rounded-lg bg-[#d4d2d2] px-6 flex items-center gap-1 text-lg ${currentPosition + 1 === aceleradores.length ? 'invisible' : ''}`}
                  style={{boxShadow: `
                    inset 0 4px 6px rgba(255, 255, 255, 0.3),
                    inset 0 -4px 6px rgba(0, 0, 0, 0.2),
                    0 4px 10px rgba(0, 0, 0, 0.25)
                  `}}
                  disabled={  currentPosition + 1 === aceleradores.length ? true : false }
                  onClick={() => ContinuarVideo(currentPosition, aceleradores, setCurrentPosition)}
                >
                  Siguiente <ArrowForwardIosIcon />
                </button>
              </section>
            )}

          </div>
        )
      )}
      {/* <div
        style={{
          height: '1.2px',
          backgroundColor: 'black',
          width: '95%',
          marginLeft: '2rem',
        }}
      ></div> */}
    </>
  )
}

export default Aceleradores